import * as p from "./positions";
import { cssColors as colors } from "./colors";

export const sections = {
  MOST: "most",
  MOVED: "moved",
  HEADLESS: "headless",
  NATURAL: "natural",
  WORLD: "world",
  MODERN: "modern",
  WOMEN: "women"
};

export const sectionMembers = {
  [sections.MOST]: ["haller", "kocher", "bubenberg"],
  [sections.MOVED]: ["erlach", /* "gotthelf", */ "zähringer", "bubenberg"],
  [sections.HEADLESS]: ["weinzäpfli", /* "wehrmänner", */ "vontavel"],
  [sections.NATURAL]: ["kopp" /*, "kuenzi", "studer" */],
  [sections.WORLD]: [
    "bolivar",
    "rizal",
    /* "titulescu", */
    "mazzini",
    "lenin",
    "refugianten"
  ],
  [sections.MODERN]: ["korenhuisbrug", "einstein", "dank", "stadionuhr"],
  [sections.WOMEN]: ["weltpost", "telegraphen", "minerva", "seiler"]
};

export const memorials = [
  // most
  {
    name: "haller",
    displayName: "Haller-Denkmal",
    positions: p.hallerPositions,
    color: colors.FIRST,
    image: require("images/haller-item.jpg")
  },
  {
    name: "kocher",
    displayName: "Kocher-Denkmal",
    positions: p.kocherPositions,
    color: colors.SECOND,
    image: require("images/kocher-kocherpark.jpg")
  },
  {
    name: "bubenberg",
    displayName: "Bubenberg-Denkmal",
    positions: p.bubenbergPositions,
    color: colors.FOURTH,
    image: require("images/bubenberg-close.jpg")
  },
  // moved
  {
    name: "erlach",
    displayName: "Erlach-Denkmal",
    positions: p.erlachPositions,
    color: colors.FIRST,
    image: require("images/erlach-ringgenpark.jpg")
  },
  // {
  //   name: "gotthelf",
  //   displayName: "Gotthelf-Denkmal",
  //   positions: p.gotthelfPositions,
  //   color: colors.SECOND,
  //   image: require("images/gotthelf_rosengarten.jpg")
  // },
  {
    name: "zähringer",
    displayName: "Zähringer-Denkmal",
    positions: p.zähringerPositions,
    color: colors.THIRD,
    image: require("images/zähringer-nydegg.jpg")
  },
  // headless
  {
    name: "weinzäpfli",
    displayName: "Theobald-Weinzäpfli-Gedenktafel",
    positions: p.weinzäpfliPositions,
    color: colors.FIRST,
    image: require("images/weinzaepfli-far.jpg")
  },
  // {
  //   name: "wehrmänner",
  //   displayName: "Wehrmänner-Denkmal",
  //   positions: p.wehrmännerPositions,
  //   color: colors.SECOND,
  //   image: require("images/wehrmaenner-close.jpg")
  // },
  {
    name: "aargauerstalden",
    displayName: "Aargauerstalden-Denkmal",
    positions: p.aargauerstaldenPositions,
    color: colors.THIRD,
    image: require("images/aargauerstalden-close.jpg")
  },
  {
    name: "vonwerdt",
    displayName: "Sigmund Rudolf von Werdt-Denkmal",
    positions: p.vonwerdtPositions,
    color: colors.FOURTH,
    image: require("images/von-werdt-far.jpg")
  },
  // natural
  {
    name: "kopp",
    displayName: "Elisabeth-Kopp-Eiche",
    positions: p.koppPositions,
    color: colors.FIRST,
    image: require("images/kopp-eiche-far.jpg")
  },
  // {
  //   name: "kuenzi",
  //   displayName: "Küenzi-Eiche",
  //   positions: p.kuenziPostitions,
  //   color: colors.SECOND,
  //   image: require("images/kocher-kocherpark.jpg")
  // },
  // {
  //   name: "studer",
  //   displayName: "Studer-Stein",
  //   positions: p.studerPositions,
  //   color: colors.THIRD,
  //   image: require("images/studer-stein-close.jpg")
  // },
  // international
  {
    name: "bolivar",
    displayName: "Simon-Bolivar-Denkmal",
    positions: p.bolivarPositions,
    color: colors.FIRST,
    image: require("images/bolivar-close.jpg")
  },
  {
    name: "rizal",
    displayName: "Rizal-Denkmal",
    positions: p.rizalPositions,
    color: colors.SECOND,
    image: require("images/rizal-close.jpg")
  },
  // {
  //   name: "titulescu",
  //   displayName: "Titulescu-Denkmal",
  //   positions: p.titulescuPositions,
  //   color: colors.THIRD,
  //   image: require("images/studer-stein-close.jpg")
  // },
  {
    name: "lenin",
    displayName: "Lenin-Haus",
    positions: p.leninPositions,
    color: colors.THIRD,
    image: require("images/lenin-close.jpg")
  },
  {
    name: "mazzini",
    displayName: "Mazzini-Denkmal",
    positions: p.mazziniPositions,
    color: colors.FOURTH,
    image: require("images/mazzini-close.jpg")
  },
  {
    name: "refugianten",
    displayName: "Refugianten-Denkmal",
    positions: p.refugiantenPositions,
    color: colors.FIFTH,
    image: require("images/refugianten-close.jpg")
  },
  // modern
  {
    name: "korenhuisbrug",
    displayName: "Korenhuisbrug (Kornhausbrücke)",
    positions: p.korenhuisbrugPositions,
    color: colors.FIRST,
    image: require("images/korenhuisbrug-far.jpg")
  },
  {
    name: "einstein",
    displayName: "Einstein-Denkmal",
    positions: p.einsteinPositions,
    color: colors.SECOND,
    image: require("images/einstein-rosengarten-close.jpg")
  },
  {
    name: "stadionuhr",
    displayName: "Alte Stadionuhr Wankdorf",
    positions: p.stadionuhrPositions,
    image: require("images/stadionuhr-far.jpg"),
    color: colors.THIRD
  },
  {
    name: "dank",
    displayName: "Ort des Dankes",
    positions: p.dankPositions,
    image: require("images/dank-far.jpg"),
    color: colors.FOURTH
  },
  // {
  //   name: "wagner",
  //   displayName: "Wagner-Stein",
  //   positions: p.wagnerPositions,
  //   color: colors.FIFTH,
  //   image: require("images/studer-stein-close.jpg")
  // },
  // women
  {
    name: "weltpost",
    displayName: "Weltpost-Denkmal",
    positions: p.weltpostPositions,
    color: colors.FIRST,
    // to do: adjust
    image: require("../images/weltpost-close.jpg")
  },
  {
    name: "telegraphen",
    displayName: "Telegraphen-Denkmal",
    positions: p.telegraphenPositions,
    color: colors.SECOND,
    // to do: adjust
    image: require("images/welttelegraphen-close.jpg")
  },
  {
    name: "minerva",
    displayName: "Minerva",
    positions: p.minervaPositions,
    color: colors.THIRD,
    // to do: adjust
    image: require("images/minverva-close.jpg")
  },
  {
    name: "seiler",
    displayName: "«Junge Frau» (Anna Seiler)",
    positions: p.seilerPositions,
    color: colors.FOURTH,
    // to do: adjust
    image: require("images/anna-seiler-close.jpg")
  }
];
